import { render, staticRenderFns } from "./AddChannelPartner.vue?vue&type=template&id=37798236"
import script from "./AddChannelPartner.vue?vue&type=script&lang=js"
export * from "./AddChannelPartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports